import { createActionGroup, props } from '@ngrx/store';
import { SyncedLessonState } from '../../public/yjs/lesson-ydoc-schema';

/**
 * Yjs lesson-state mirror actions (lib-internal — NOT exported from `index.ts`).
 *
 * Dispatched by `LessonYjsMirrorEffects` whenever the Y.Doc Y.Map changes; consumed
 * only by `lesson-reducer`. Their sole purpose is to keep classroom selectors fed
 * with a projection of the Y.Doc state.
 *
 * Application code MUST NOT dispatch these. To read Y.Doc state, inject
 * `ClassroomFacade` (`state$`, `changes$`, `primarySlideHistory$`, …) or read
 * the existing classroom selectors. To write Y.Doc state, call facade methods
 * directly — there is no public action API for writes.
 */
export const yjsStateActions = createActionGroup({
    source: 'YjsLessonState',
    events: {
        /** Y.Map state changes (local + remote) mirrored from Y.Doc into NgRx. */
        lessonStateMirrored: props<{ changes: Partial<SyncedLessonState> }>(),
    },
});
